var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.21094 11.9658C6.21094 9.13739 6.21094 7.72318 7.08962 6.8445C7.9683 5.96582 9.38251 5.96582 12.2109 5.96582H16.2109C19.0394 5.96582 20.4536 5.96582 21.3323 6.8445C22.2109 7.72318 22.2109 9.13739 22.2109 11.9658V18.7934C22.2109 21.4767 22.2109 22.8184 21.3666 23.2287C20.5224 23.6391 19.4674 22.8102 17.3575 21.1524L16.6822 20.6218C15.4958 19.6897 14.9027 19.2236 14.2109 19.2236C13.5192 19.2236 12.926 19.6897 11.7397 20.6218L11.0644 21.1524C8.95448 22.8102 7.89952 23.6391 7.05523 23.2287C6.21094 22.8184 6.21094 21.4767 6.21094 18.7934V11.9658Z",
    stroke: "#167092",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.2b49f3e147665e2f256391756122132e.svg";
export { ForwardRef as ReactComponent };